import * as React from "react";
import { Modal, Badge, Select, DatePicker, Icon, message, Spin } from "antd";
import { LocalStorageMock } from "./../../../common/utils";

interface Props {
  visible: boolean;
  onClose(): void;
}

export class TermsOfService extends React.Component<Props, any> {
  render() {
    let localStorage = window.localStorage
      ? window.localStorage
      : LocalStorageMock;
    return (
      <Modal
        title="TERMS AND CONDITIONS OF USE"
        visible={!localStorage.getItem("agreedToTOS") && this.props.visible}
        onOk={() => {
          localStorage.setItem("agreedToTOS", "true");
          this.props.onClose();
        }}
        wrapClassName="tos-modal"
        okText={"I Agree"}
        maskClosable={true}
      >
        <div>
          RETAILER DASHBOARD TERMS AND CONDITIONS OF USE
          <br /> <br />
          This is a legally binding agreement (the "Agreement") between Flipp
          Corporation ("Flipp") and you (an authorized representative of the
          merchant associated with this account) ("You" or "Merchant"). As it
          contains important information regarding Your legal rights, please
          review the following terms and conditions carefully before accepting
          to use Flipp’s flyer platform (“Flyer Platform”) and the associated
          retailer dashboard ("Retailer Dashboard"). Furthermore, the terms and
          conditions in this Agreement may be amended from time to time by
          Flipp, in its sole discretion and without notice, and thus, please
          review this Agreement whenever You use the Retailer Dashboard. This
          Agreement will be readily accessible in the footer of the Retailer
          Dashboard, with the date on which it was last updated indicated in the
          text. You understand and agree that Your continued use of the Retailer
          Dashboard after any such changes constitutes Your acceptance of the
          revised Agreement.
          <br /> <br />
          IF YOU DO NOT AGREE TO THIS AGREEMENT, YOU MAY NOT USE THE Retailer
          Dashboard.
          <br /> <br />
          1. Prerequisite
          <br /> <br />
          You acknowledge that You have entered into a service agreement for the
          use of the Flyer Platform with Flipp (the “Service Agreement”). Unless
          Flipp consents to Your use of the Retailer Dashboard in writing, You
          may not use the Retailer Dashboard without a valid Service Agreement.
          If You have not entered into a valid Service Agreement with Flipp,
          please contact a representative of Flipp.
          <br /> <br />
          In the event of any inconsistency or conflict between this Agreement
          and the Service Agreement, such inconsistency or conflict shall be
          resolved in favour of the Service Agreement.
          <br /> <br />
          2. TERM
          <br /> <br />
          This Agreement shall be effective from the date You first used the
          Retailer Dashboard and shall continue until (i) the termination of the
          Service Agreement, or (ii) if You do not have a valid Service
          Agreement but Flipp consented in writing to Your use, then until You
          cease use of the Retailer Dashboard or Flipp terminates this Agreement
          by either providing notice to You or disabling Your account (“Term”).
          Upon termination, You and Your Representatives shall cease all use of
          the Retailer Dashboard.
          <br /> <br />
          Upon termination of this Agreement, Sections 5, 6, 7, 8, 9 and 10
          shall remain in full force and effect.
          <br /> <br />
          3. CONDITIONS OF USE
          <br /> <br />
          3.1 Use: Subject to the terms and conditions of this Agreement, Flipp
          hereby grants Merchant a non-exclusive, non-transferable, and
          non-sublicensable right to use the Retailer Dashboard during the Term.
          Additionally, Merchant’s Representatives shall be permitted to use the
          Retailer Dashboard during the Term as necessary for Merchant to fully
          realize the benefit of the Retailer Dashboard. Merchant shall ensure
          that it and its Representatives comply with this Agreement and all
          applicable laws. Merchant shall be liable for any breach of this
          Agreement by any of its Representatives.
          <br /> <br />
          3.2 Restrictions: You agree to the following restrictions on its and
          its Representatives’ use of the Retailer Dashboard:
          <br /> <br />
          (a) Not to circumvent (e.g. decompiling, reverse engineering,
          disassembling or modifying) or otherwise interfere with the proper
          functioning of the Retailer Dashboard;
          <br /> <br />
          (b) Not to disseminate account login information or information
          obtained through the Retailer Dashboard to any party other than its
          Representatives. At no point shall Merchant provide access to the
          Retailer Dashboard to any direct competitor of Flipp;
          <br /> <br />
          (c) Keep all account login information confidential, current and up to
          date. Account logins are unique to one user and must not be shared or
          used by more than one user but the user account may be reassigned to a
          new user as needed;
          <br /> <br />
          (d) Not to use any security testing tools in order to probe, scan or
          attempt to penetrate or ascertain the security of the Retailer
          Dashboard; and
          <br /> <br />
          (e) Not to create derivative works of the Retailer Dashboard.
          <br /> <br />
          4. Uploaded Content
          <br /> <br />
          For any content or information provided to Flipp (including uploaded
          content) (“Merchant Content”) while using the Retailer Dashboard, You
          acknowledge that You have all necessary rights to such Merchant
          Content. You further agree to grant to Flipp, during the Term of this
          Agreement, a non-exclusive, royalty-free right and license to use such
          Merchant Content, in connection with the Flyer Platform and Retailer
          Dashboard.
          <br /> <br />
          5. SUGGESTIONS, COMMENTS AND FEEDBACK
          <br /> <br />
          For any suggestions, comments, or other feedbacks ("Feedback")
          disclosed, submitted or offered to Flipp and/or its Affiliates, You
          grant Flipp and its Affiliates a perpetual, royalty-free, irrevocable,
          transferable, unrestricted, and sub-licensable right and license to
          use the Feedback as Flipp desires. You agree that Flipp and its
          Affiliates shall be free to use, disclose, reproduce, license or
          otherwise distribute and exploit the Feedback provided to it as it
          sees fit. You hereby waive all Your moral rights in the Feedback for
          the benefit of Flipp and its Affiliates and the respective successors,
          assigns and licensees.
          <br /> <br />
          You represent and warrant that the Feedback You disclose, submit, or
          otherwise offer to Flipp and/or its Affiliates is entirely without
          obligation or restriction of any kind on account of intellectual
          property rights or otherwise, and that the Feedback complies with this
          Agreement. You further represent and warrant that the Feedback will
          not cause injury to any person or entity and that it will not contain
          any harmful, threatening, unlawful, defamatory, infringing, abusive,
          inflammatory, harassing, vulgar, obscene, fraudulent, invasive of
          privacy or publicity rights, hateful, or racially, ethnically or
          otherwise objectionable content.
          <br /> <br />
          Notwithstanding anything in this Section 5, Flipp and/or its
          Affiliates shall have no obligation: (i) to display, maintain or use
          the Feedback in any way; (ii) to keep Your Feedback confidential; and
          (iii) to notify You that Flipp or its Affiliate has resolved, used,
          licensed, sub-licensed, transferred, disclosed or otherwise used the
          Feedback.
          <br /> <br />
          If You do not agree with this Section 5, do not send us any Feedback.
          <br /> <br />
          6. PROPRIETARY RIGHTS
          <br /> <br />
          You acknowledge and agree that the Retailer Dashboard contains
          proprietary and confidential information that is protected by
          applicable intellectual property and other laws. Except as expressly
          stated in this Agreement or the Service Agreement, nothing in this
          Agreement shall be interpreted to confer to You any title or ownership
          to the Retailer Dashboard or any intellectual property rights therein.
          <br /> <br />
          7. DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY
          <br /> <br />
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, AND EXCEPT AS
          OTHERWISE EXPRESSLY PROVIDED IN THE SERVICE AGREEMENT, THE Retailer
          Dashboard (AND ALL CONTENT THEREIN) IS PROVIDED "AS IS" AND "AS
          AVAILABLE", WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND, EITHER
          EXPRESS, IMPLIED OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, THE
          IMPLIED WARRANTIES AND/OR CONDITIONS OF MERCHANTABILITY, OF
          SATISFACTORY QUALITY, OF FITNESS FOR A PARTICULAR PURPOSE, OF
          ACCURACY, OF QUIET ENJOYMENT, AND NON-INFRINGEMENT OF THIRD PARTY
          RIGHTS.
          <br /> <br />
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, AND EXCEPT AS
          OTHERWISE EXPRESSLY PROVIDED IN THE SERVICE AGREEMENT, FLIPP’S TOTAL
          LIABILITY TO YOU FOR ALL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
          DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, AND
          PUNITIVE DAMAGES WHETHER SUCH CLAIM IS BASED ON WARRANTY, CONTRACT,
          TORT (INCLUDING NEGLIGENCE)) EXCEED THE AMOUNT OF FIFTY DOLLARS
          ($50.00).
          <br /> <br />
          8. CONFIDENTIAL INFORMATION
          <br /> <br />
          The Retailer Dashboard provides You with access to various information
          that may be confidential (“Confidential Information”). Unless Flipp
          and You have a separate and valid non-disclosure agreement in place,
          in which case such non-disclosure agreement shall take control, You
          may not use or disclose such Confidential Information without Flipp’s
          written consent. However, You may (i) disclose Confidential
          Information to Your Representative on a need-to-know basis, and (ii)
          use Flipp Confidential Information, in connection with this Agreement
          or the Service Agreement.
          <br /> <br />
          Upon termination of this Agreement or the Service Agreement, or upon
          Flipp’s written request, You agree to return or destroy all
          Confidential Information. Further, within 5 business days of Flipp’s
          written request, You shall certify in writing that all Confidential
          Information has been destroyed or returned.
          <br /> <br />
          9. GENERAL
          <br /> <br />
          Subject to the Service Agreement, parties agree as follows: No
          Assignment. You may not assign any part of this Agreement to any
          party. No Waiver. The failure of either party to enforce any provision
          of the Agreement will not constitute a waiver. Severability. If any
          provision of this Agreement shall be deemed unlawful, invalid, or
          unenforceable by a court of law, then the impugned provision shall be
          deemed severed and shall not affect the validity and enforceability of
          any remaining provisions. Governing Law; Venue. All claims arising out
          of or relating to this Agreement will be governed by Ontario law,
          excluding any conflict of laws rules, and will be litigated
          exclusively in the federal or provincial courts of Toronto, Ontario,
          and You and Flipp consent to personal jurisdiction in those courts.
          However, the foregoing shall not prevent either party from seeking
          equitable relief or enforcing a judgment in another jurisdiction.
          Including. Where the word “including” or “includes” is used in this
          Agreement, it means “including (or includes) without limitation.
          Headings. Headings of sections are inserted for convenience of
          reference only and do not affect the construction or interpretation of
          this Agreement. Notices. Except as expressly set out in this Agreement
          to the contrary, all notices by (i) Flipp shall be provided to you by
          e-mail specified in Your account and shall be deemed delivered one
          business day following the sending of the e-mail, and (ii) You shall
          be provided by courier to the address provided in the preamble, “ATTN:
          LEGAL”, with a copy to legal@flipp.com.
          <br /> <br />
          10. Definitions
          <br /> <br />
          "Affiliate" shall mean, with respect to an entity, any person or
          entity that directly or indirectly owns, is owned by, or is under
          common ownership with that entity. For purposes of this definition,
          ownership means control of more than a 50% interest in an entity.
          <br /> <br />
          “Representatives” shall mean an entity’s employee, director, officer,
          legal counsel, financial advisor (including accountants and auditors),
          and agent.
          <br /> <br />
          Last Updated: December 5, 2017
          <br /> <br />
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/AnalyticsContainer/terms_of_service.tsx